export default ({ $sitewideData, $integrationsManager }) => {
    $integrationsManager.loaders.onLoadLoader(() => {
        /* eslint-disable */
        // prettier-ignore
        (function(i,n,v,o,c,a) { i.InvocaTagId = o; var s = n.createElement('script'); s.type = 'text/javascript';
        s.async = true; s.src = ('https:' === n.location.protocol ? 'https://' : 'http://' ) + v;
        var fs = n.getElementsByTagName('script')[0]; fs.parentNode.insertBefore(s, fs);
        })(window, document, 'solutions.invocacdn.com/js/invoca-latest.min.js', `${$sitewideData.config.invocaNetworkId}/${$sitewideData.config.invocaTagId}`);
        /* eslint-enable */
    })

    const changePhone = () => {
        if (
            window.Invoca &&
            typeof window.Invoca.shouldRun === 'function' &&
            window.Invoca.shouldRun()
        ) {
            if (window.Invoca.PNAPI && typeof window.Invoca.PNAPI.run === 'function')
                window.Invoca.PNAPI.run()
        }
    }

    return {
        changePhone,
    }
}
